import { supabase } from '../../supabaseClient';

const ENDPOINT = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/admin-users`;
const ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const callAdminUsers = async (action, payload = {}) => {
  const session = supabase.auth.session();
  const token = session?.access_token;
  if (!token) {
    return { error: { message: 'Sessão expirada. Faça login novamente.' } };
  }

  try {
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        apikey: ANON_KEY,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ action, ...payload }),
    });

    let body = null;
    try {
      body = await res.json();
    } catch {
      body = null;
    }

    if (!res.ok) {
      return { error: { message: body?.error || 'Erro na operação', status: res.status } };
    }
    return { data: body?.data ?? body };
  } catch (e) {
    return { error: { message: e?.message || 'Falha de rede' } };
  }
};
